import { ColumnListDto } from '@common/dto/column/list-dto';
import { HttpSuccessDto } from '@common/dto/http';
import { InviteListDto } from '@common/dto/invite/list-dto';
import { PedigreeListDto } from '@common/dto/pedigree/list-dto';
import { clientTransformed } from '@common/utils/rest';

const URL_PREFIX = 'api/invites';

const getUrl = (path: string) => {
  return `${URL_PREFIX}/${path}`;
};

export type GetInvitesRequestFiltering = {
  filterApplied: boolean;
  columnFilters: {};
  columns: Array<ColumnListDto>;
  pedigreeId: PedigreeListDto['id'];
};

export type GetInvitesRequestPagination = {
  start: number;
  size: number;
};

export type GetInvitesRequestParams = {
  filtering: GetInvitesRequestFiltering;
  pagination: GetInvitesRequestPagination;
};

export const getInvites = ({ filtering, pagination }: GetInvitesRequestParams): Promise<{ data: Array<InviteListDto>; totalCount: number; }> => {
	return clientTransformed({
    path: getUrl('smartlist'),
    method: 'POST',
		entity: {
			...filtering,
			...pagination,
		},
  }).then(
    (response: HttpSuccessDto<{ data: Array<InviteListDto>; totalCount: number; }>) => {
      return response.entity;
    },
  );
};